// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TaobaoSquareFilledSvg from "@ant-design/icons-svg/es/asn/TaobaoSquareFilled";
import AntdIcon from '../components/AntdIcon';

var TaobaoSquareFilled = function TaobaoSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TaobaoSquareFilledSvg
  }));
};

TaobaoSquareFilled.displayName = 'TaobaoSquareFilled';
export default React.forwardRef(TaobaoSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/TaobaoSquareFilled.js
// module id = 1929
// module chunks = 0